import { render, staticRenderFns } from "./layout.html?vue&type=template&id=2dc55ef1&scoped=true&external"
import script from "./layout.js?vue&type=script&lang=js&external"
export * from "./layout.js?vue&type=script&lang=js&external"
import style0 from "./layout.scss?vue&type=style&index=0&id=2dc55ef1&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc55ef1",
  null
  
)

export default component.exports